export default __webpack_public_path__ + "static/media/カチ.c5b618c5.mp3";